import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { ProductTypeRequest, ProductTypesService } from '@src/app/shared/backend/clients';
import { ComboData } from '@src/app/shared/components/comboData/comboData';
import { BaseViewComponent } from '@src/app/shared/components/base-list/base-view.component';

@Component({
    selector: 'app-add-product-type',
    templateUrl: './add-product-type.component.html',
    styleUrl: './add-product-type.component.scss',
    host: {
        class: 'app-add-product-type'
    },
    standalone: false
})
export class AddProductTypeComponent extends BaseViewComponent implements OnInit {

  comboData: ComboData = new ComboData(async (filter) => await firstValueFrom(this.productTypesService.apiProductTypesFilterComboPost(filter)));

  public productTypeForm: FormGroup = this.fb.group({
    name: ['', [Validators.required, Validators.maxLength(100)]],
    code: ['', [Validators.required, Validators.maxLength(50)]],
    hasParentProductType: ['false'],
    productTypeId: [[]],
    imageUrl: [null]
  },
  { validators: this.conditionalValidators() });

  constructor(
    private router: Router,
    private productTypesService: ProductTypesService,
    private fb: FormBuilder
  ) { super(); }

  ngOnInit() {
    this.init();
  }

  private async init(): Promise<void> {
    await this.initComboData();
  }

  private async initComboData() {
    await this.comboData.getData(null, 1);
  }

  getComboTotalPages(): number {
    const totalRecords = this.comboData?.totalRecords ?? 0;
    const pageSize = Number(this.comboData?.rowsPerPageOption) || 5;

    return Math.max(1, Math.ceil(totalRecords / pageSize));
  }

  async onLazyLoadComboData(event: any) {
    const search = event?.search?.trim() || null;
    const activePage = Math.max(1, (event?.pageIndex ?? 1));

    await this.comboData.getData(search, activePage);
  }

  conditionalValidators(): ValidatorFn {
    return (formGroup: AbstractControl): { [key: string]: any } | null => {
      const hasParentProductType = formGroup.get('hasParentProductType')?.value;
      const productType = formGroup.get('productTypeId')?.value ?? [];

      if (hasParentProductType === 'true' && productType.length === 0) {
        return { requiredproductType: true };
      }


      return null;
    };
  }

  isProductTypeRequired(): boolean {
    return this.productTypeForm.get('hasParentProductType')?.value === 'true';
  }

  async submitForm() {
    if (this.productTypeForm.valid) {

      const payload: ProductTypeRequest = {
        name: this.productTypeForm.controls['name'].value,
        code: this.productTypeForm.controls['code'].value,
        imageUrl: this.productTypeForm.controls['imageUrl'].value,
        parentId: this.productTypeForm.controls['productTypeId'].value?.[0]
      };

      await firstValueFrom(this.productTypesService.apiProductTypesCreatePost(payload));

      this.productTypeForm.controls['name'].setValue(null);
      this.productTypeForm.controls['code'].setValue(null);
      this.productTypeForm.controls['imageUrl'].setValue(null);
      this.productTypeForm.controls['productTypeId'].setValue([]);

      this.router.navigate(['/product-types']);
    }
  }
}
